<template>
    <div class="data-view-item">
        <h1>Stats global {{ entityVerbose }} par jour</h1>
        <ConsumptionTable :entity="entity" :data="consumptionData" table-type="daily"></ConsumptionTable>
        <div
            v-if="powerData.length > 0"
            class="power-graphs-container"
        >
            <PowerGraph
                v-for="(item, index) in powerData"
                :key="index"
                :entity="entity"
                :uid="`${uid}-daily-${index}`"
                :date="item.date"
                :power-data="item.data"
            ></PowerGraph>
        </div>
    </div>
</template>

<script>
import PowerGraph from './PowerGraph.vue';
import ConsumptionTable from './ConsumptionTable.vue';
    export default {
        name: 'GlobalDataView',
        components: {
            ConsumptionTable,
            PowerGraph
        },
        props:{
            entity:{
                type: String,
                required: true
            },
            uid:{
                type: String,
                required: true
            },
            consumptionData:{
                type: Array,
                required: true
            },
            powerData:{
                type: Array,
                required: true
            }
        },
        computed:{
            entityVerbose(){
                switch (this.entity) {
                    case 'zone':
                        return 'de la zone';
                    case 'machine':
                        return 'de la machine';
                    case 'workshop':
                        return 'de l\'atelier';
                    case 'motor':
                        return 'du moteur';
                    default:
                        return 'du site';
                }
            }
        },
    }
</script>

<style lang="scss" >

</style>


// WEBPACK FOOTER //
// src/components/page/DataView/DailyDataView.vue